import { useRef, useEffect, useState } from "react";
import goodwe_esa_banner from "../../../assets/goodwe_esa_banner.jpg";
import '../AlphaEss.css';
import { Link } from 'react-router-dom';

const productName = "GoodWe ESA";

export default function ProductHero() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`alpha-proven-brands-section ${inView ? "alpha-hero-in-view" : ""}`}>
      <div className="alpha-brands-content">
        <div className="alpha-brands-image-container">
          <img
            src={goodwe_esa_banner}
            alt="Modern home with solar battery system"
            className="alpha-brands-image"
          />
        </div>
        <div className="alpha-brands-info-card">
          <h1>{productName}</h1>
          <h2>All-in-one solar and storage solution</h2>
          <p className="alpha-info-footer-list">
            The {productName} delivers reliable whole-home backup power with strong built-in safety protection, providing secure and stable energy for Australian homes.
          </p>
          <div className="free_quote_div">
            <Link to="/contact" className="free_quote_btn">
              Get Free Quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
